import { useState, useEffect } from 'react';
import api from '../services/api';
import { getErrorMessage } from '../services/errorMessages';
import { FiPlus, FiTrash2, FiEdit2, FiX, FiMapPin } from 'react-icons/fi';
import ConfirmModal from '../components/ConfirmModal';
import './Pages.css';

const Cities = () => {
  const [cities, setCities] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [confirmAction, setConfirmAction] = useState(null);

  const fetchCities = async () => {
    try {
      const { data } = await api.get('/cities');
      setCities(data);
    } catch { /* ignored */ }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchCities(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (editing) {
        await api.put(`/cities/${editing}`, { name });
      } else {
        await api.post('/cities', { name });
      }
      setShowModal(false);
      setEditing(null);
      setName('');
      fetchCities();
    } catch (err) {
      setError(getErrorMessage(err));
    }
  };

  const handleEdit = (city) => {
    setName(city.name);
    setEditing(city.id);
    setError('');
    setShowModal(true);
  };

  const handleDelete = (city) => {
    setConfirmAction({
      title: 'ქალაქის წაშლა',
      message: `ნამდვილად გსურთ "${city.name}"-ის წაშლა?`,
      type: 'delete',
      onConfirm: async () => {
        try {
          await api.delete(`/cities/${city.id}`);
          fetchCities();
        } catch (err) {
          alert(getErrorMessage(err));
        }
        setConfirmAction(null);
      },
    });
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>ქალაქები</h1>
          <p className="page-subtitle">ქალაქების მართვა</p>
        </div>
        <button className="btn-primary" onClick={() => { setName(''); setEditing(null); setError(''); setShowModal(true); }}>
          <FiPlus /> დამატება
        </button>
      </div>

      {loading ? (
        <div className="loading">იტვირთება...</div>
      ) : (
        <div className="cards-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
          {cities.map((c) => (
            <div key={c.id} className="data-card">
              <div className="card-header-row">
                <div className="card-avatar" style={{ background: 'linear-gradient(135deg, #14b8a6, #0ea5e9)' }}>
                  <FiMapPin />
                </div>
                <div>
                  <h3>{c.name}</h3>
                </div>
              </div>
              <div className="card-actions">
                <button className="btn-icon btn-edit" onClick={() => handleEdit(c)} title="რედაქტირება"><FiEdit2 /></button>
                <button className="btn-icon btn-danger" onClick={() => handleDelete(c)} title="წაშლა"><FiTrash2 /></button>
              </div>
            </div>
          ))}
          {cities.length === 0 && <div className="empty-state-card">ქალაქები არ არის</div>}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => { setShowModal(false); setEditing(null); }}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editing ? 'ქალაქის რედაქტირება' : 'ახალი ქალაქი'}</h3>
              <button className="btn-icon" onClick={() => { setShowModal(false); setEditing(null); }}><FiX /></button>
            </div>
            <form onSubmit={handleSubmit} className="modal-form">
              {error && <div className="error-message">{error}</div>}
              <div className="form-group">
                <label>ქალაქის სახელი</label>
                <input value={name} onChange={(e) => setName(e.target.value)} placeholder="მაგ. თბილისი" required />
              </div>
              <button type="submit" className="btn-primary btn-full" disabled={!name.trim()}>{editing ? 'შენახვა' : 'დამატება'}</button>
            </form>
          </div>
        </div>
      )}

      {confirmAction && <ConfirmModal {...confirmAction} onCancel={() => setConfirmAction(null)} />}
    </div>
  );
};

export default Cities;
